import {
  subscriptionTypes,
  legacySubscriptionTypes,
  subscriptionLanguage,
} from './constants.js';

export default function getPricing(keepPrice = false) {
  if (keepPrice) {
    return Object.fromEntries(
      Object.values(subscriptionTypes).map((type) => {
        const legacy = legacySubscriptionTypes.find(
          (legacyType) =>
            legacyType.code === type.code &&
            legacyType.language === subscriptionLanguage.SPANISH
        );

        return [type.code, { ...legacy, name: type.name }];
      })
    );
  }

  return {
    teacherPro: subscriptionTypes.teacherPro,
    teacher: subscriptionTypes.teacher,
    family: subscriptionTypes.family,
  };
}
